const r=(l,e)=>{const o=e?.errors[l.name]&&e?.touched[l.name],i=!(e!=null&&e.errors[l.name])&&e?.touched[l.name];return{isInvalid:o,isValid:i}};export{r as useFormikFieldValidation};
